require("./o-social-networks.scss");

// JavaScript
var $ = require("jquery"),
    $fbHolder = $(".o-social-networks__facebook"),
    $fbPage = $(".o-social-networks__facebook-iframe");

$(window).on("load", function () {
    (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/fr_CA/sdk.js#xfbml=1&version=v3.2';
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
});

// Reload Facebook widget on window resize
if ($fbHolder.length > 0 && $fbPage.length > 0) {
    var timeout = null;

    var fnResize = function () {
        // Hide FB Frame (solve problem when retrieving width / height)
        $fbPage.hide();
        // Get dimension
        var fbWidth = Math.round($fbHolder.width());
        var fbHeight = Math.round($fbHolder.height());
        // Restore visibility
        $fbPage.show();
        // Apply new dimension
        if (!isNaN(fbWidth) && !isNaN(fbHeight)) {
            $fbPage.attr("data-width", fbWidth);
            $fbPage.attr("data-height", fbHeight);
            if (window.FB) {
                window.FB.XFBML.parse();
            }
        }
    };

    var fnDebounceResize = function () {
        clearTimeout(timeout);
        timeout = setTimeout(fnResize, 300);
    };

    $(window).on("resize", fnDebounceResize);

    fnResize();
}


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/organism/o-social-networks/o-social-networks.chunk.js